const routes = [
    // 外教课表管理路由
    {
      path: "/foreignSchedule",
      name: "foreignSchedule",
      meta: {
        title: "课表管理",
        volcengine: true
      },
      component: () => import("@/pages/lsForeign/foreignSchedule/index.vue")
    },
  ];
  export default routes;